var newsletterView = Backbone.View.extend({
  events: {
    "submit [data-newsletter-form]": "processData",
    "click [data-newsletter-reset]": "resetNewsletter"
  },
  processData: function(e) {
    bodyClass = this.$el.is("[data-global-class]");
    contact = this.$el.is("[data-contact]");
    this.url = $(e.currentTarget).attr("action");
    this.data = $(e.currentTarget).serializeArray();
    e.preventDefault();
    $.ajax({
      type: "post",
      url: this.url,
      data: this.data,
      beforeSend: function() {
        this.$el.addClass("is-loading");
      }.bind(this),
      success: function(data) {
        if (data.success) {
          this.$el.removeClass("is-loading").addClass("is-done");
          if (bodyClass) {
            //checks if form also works as a contact form
            if (contact) {
              $("body").addClass("contact-success");
            } else {
              $("body").addClass("newsletter-success");
            }
          }
        } else {
          this.$el.removeClass("is-loading").addClass("is-error");
          if (bodyClass) {
            $("body").addClass("newsletter-error");
          }
        }
      }.bind(this),
      error: function() {
        this.$el.removeClass("is-loading").addClass("is-error");
        if (bodyClass) {
          if (contact) {
            $("body").addClass("contact-error");
          } else {
            $("body").addClass("newsletter-error");
          }
        }
      }.bind(this)
    });
  },
  resetNewsletter: function(e) {
    $("[data-newsletter]").removeClass("is-done is-error");
    if (bodyClass) {
      if (contact) {
        $("body").removeClass("contact-error contact-success");
      } else {
        $("body").removeClass("newsletter-error newsletter-success");
      }
    }
    $("[data-newsletter-form]").trigger("reset");
  }
});

module.exports = newsletterView;
